import { blockOnNavigationCancelLabel } from 'owa-locstrings/lib/strings/blockonnavigationcancellabel.locstring.json';
import { blockOnNavigationContinueLabel } from 'owa-locstrings/lib/strings/blockonnavigationcontinuelabel.locstring.json';
import { blockOnNavigationMessage } from 'owa-locstrings/lib/strings/blockonnavigationmessage.locstring.json';
import { blockOnNavigationTitle } from 'owa-locstrings/lib/strings/blockonnavigationtitle.locstring.json';
import loc from 'owa-localize';

import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { getComposeHostItemIndex, isAnyNonAutoRunUilessAddinRunning } from 'owa-addins-core';

export default async function canNavigateAway(formId: string): Promise<boolean> {
    const resolveImmediately = !isAnyNonAutoRunUilessAddinRunning(getComposeHostItemIndex(formId));
    const response: DialogResponse = await confirm(
        loc(blockOnNavigationTitle),
        loc(blockOnNavigationMessage),
        resolveImmediately,
        {
            okText: loc(blockOnNavigationContinueLabel),
            cancelText: loc(blockOnNavigationCancelLabel),
        }
    );

    return response === DialogResponse.ok;
}
